import { render, staticRenderFns } from "./wechatPreview.vue?vue&type=template&id=374931c5&"
import script from "./wechatPreview.vue?vue&type=script&lang=js&"
export * from "./wechatPreview.vue?vue&type=script&lang=js&"
import style0 from "./wechatPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports